import { cn } from "../../lib/utils";
import type { RefundRequestStatus } from "../orders/types";

export const REFUND_STATUS_LABEL: Record<RefundRequestStatus, string> = {
  requested: "Requested",
  processing: "Refund in progress",
  refunded: "Refunded",
  rejected: "Rejected",
  failed: "Refund failed",
};

const TONE: Record<RefundRequestStatus, string> = {
  requested: "border-warning/30 bg-warning-soft text-warning",
  processing: "border-info/30 bg-info-soft text-info",
  refunded: "border-success/30 bg-success-soft text-success",
  rejected: "border-line bg-soft text-ink-3",
  failed: "border-danger/30 bg-danger-soft text-danger",
};

export function RefundStatusBadge({ status }: { status: RefundRequestStatus }) {
  return (
    <span className={cn("inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold", TONE[status])}>
      {REFUND_STATUS_LABEL[status]}
    </span>
  );
}
